// Base
import { BaseApi } from 'api/base.api'

// Interface
import {
  IFieldApi,
  IFieldApiRequest,
  IFieldApiGetDropdownAttrs,
  IFieldApiDropdownResponse,
} from 'interfaces/back-office/master/field/field-api.interface'

// Constant
import { ApiConstant } from 'constant'

// Utils
import { axios_renderUrl } from 'utils'

export class FieldApi extends BaseApi<IFieldApi> implements IFieldApiRequest {
  readonly url = ApiConstant.MASTER_FIELD_URL
  private fieldUrl = axios_renderUrl(this.url, ApiConstant.BACK_OFFICE)

  /**
   * @description Get field dropdown
   *
   * @method POST
   * @access private (only user that logged in)
   *
   * @param {IFieldApiGetDropdownAttrs} payload
   *
   * @return {Promise<IFieldApiDropdownResponse>} Promise<IFieldApiDropdownResponse>
   */
  async masterField_getFieldDropdown(payload: IFieldApiGetDropdownAttrs): Promise<IFieldApiDropdownResponse> {
    try {
      const response = await this.POST(`${this.fieldUrl}/dropdown`, {}, { ...payload.requestConfig })

      return Promise.resolve(response)
    } catch (err) {
      return Promise.reject(err)
    }
  }
}
